// One sentence, shown in two places: the note under the last card at the cap,
// and the tooltip on the error row when a shipment arrives over it. Kept here
// so the two can't drift apart.
export function lineItemsLimitExplanation(maxLineItems: number): string {
  return `Individual shipments cannot contain more than ${maxLineItems} line items. Handling units with the same dimensions and weight should be entered as one line item with the quantity. Please contact our team if you have any questions about this.`;
}
